import { Component, OnInit, ViewChild } from "@angular/core";
import { StripeSource } from "stripe-angular";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { BaseService } from "./../base.service";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
})
export class PaymentComponent implements OnInit {
  invalidError: any;
  cardReady = false;
  errorShow = false;
  btnDisable = false;
  extraData = {
    //name: "ajay",
  };
  model: any = {};
  constructor(
    private route: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private baseService: BaseService,
    private router: ActivatedRoute
  ) {}
  @ViewChild("stripeCard") stripe: any;

  ngOnInit(): void {
    this.router.params.subscribe((params) => {
      this.model.content_id = params["public_id"];
      this.model.status = params["slug"];
      this.model.content_type = params["type"];
    });
  }
  getToken() {
    this.btnDisable = true;
    this.spinner.show();
    this.stripe.createToken();
  }

  onStripeError(error: Error) {}

  onStripeInvalid(error: Error) {}
  setStripeToken(token: stripe.Token) {
    // this.spinner.show();
    this.errorShow = true;
    this.model.transaction_id = token.id;
    this.buyContent();
  }
  setStripeSource(source: StripeSource) {}

  buyContent() {
    this.baseService.buyContent(this.model).subscribe(
      (data) => {
        if (data) {
          this.btnDisable = true;
          this.spinner.hide();
          this.toastr.success(data.result.message, "Success!", {
            closeButton: true,
          });
          if (this.model.content_type === "video") {
            this.route.navigate(["/video-detail", this.model.content_id]);
          } else {
            this.route.navigate(["/series", this.model.content_id]);
          }
        }
      },
      (err) => {
        this.btnDisable = true;
        if (err.error.code == 500) {
          this.spinner.hide();
          this.toastr.error("Invalid card detail.", "OOPS!", {
            closeButton: true,
          });
          //Incorrect integer value: 'cus_I0Xik2wsc9XKVb
        } else if (err.error.code == "card_declined") {
          this.spinner.hide();
          this.toastr.error("Invalid card detail.", "OOPS!", {
            closeButton: true,
          });
          //Your card was declined. Your request was in test mode, but used a non test (live) card. For a list of valid test cards, visit: https://stripe.com/docs/testing.
        } else if (err.error.code == "resource_missing") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
          //No such price: 'price_1HQ9FTA8lqZeqjmXmdky8SjM222
        } else if (err.error.code == "expired_card") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
          //Your card has expired
        } else if (err.error.code == "incorrect_cvc") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
          //Your card's security code is incorrect.
        } else if (err.error.code == "processing_error") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
          //An error occurred while processing your card. Try again in a little bit.
        } else if (err.error.code == "incorrect_number") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        } else if (err.error.code == "risk_level") {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        } else {
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      }
    );
  }
}
